import EvolutionFrame from '@/src/components/Player/GameFrame/EvolutionFrame.tsx'
import styles from '@/src/components/Player/GameFrame/GameFrame.module.scss'
import MicrogamingFrame from '@/src/components/Player/GameFrame/MicrogamingFrame.tsx'
import PlayNGoFrame from '@/src/components/Player/GameFrame/PlanNGoFrame.tsx'
import useEventListener from '@/src/hooks/useEventListener.tsx'
import useTimeout from '@/src/hooks/useTimeout.tsx'
import { FamilyType } from '@/src/services/types/games.tsx'
import { Dispatch, SetStateAction, useRef } from 'react'

const FrameSelector = ({
  gameFamily,
  classNames,
  setIframeLoading,
  gameUrl,
}: {
  gameFamily: FamilyType
  gameUrl: string
  classNames?: string
  setIframeLoading: Dispatch<SetStateAction<boolean>>
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEventListener(
    'load',
    () => {
      setTimeout(() => setIframeLoading(false), 1500)
    },
    iframeRef,
  )

  useTimeout(() => {
    setIframeLoading(false)
  }, 10000)

  return (
    <>
      {(gameFamily.provider === 3 && (
        <PlayNGoFrame
          url={gameUrl}
          className={`${classNames}`}
          iframeRef={iframeRef}
        />
      )) ||
        (gameFamily.provider === 23 && (
          <EvolutionFrame
            url={gameUrl}
            iframeRef={iframeRef}
            className={styles.iframe}
          />
        )) ||
        (gameFamily.provider === 1 && (
          <MicrogamingFrame
            url={gameUrl}
            className={`${classNames}`}
            iframeRef={iframeRef}
          />
        )) || (
          <iframe
            data-testid='game-iframe'
            ref={iframeRef}
            src={gameUrl}
            className={`${classNames}`}
            scrolling='no'
          />
        )}
    </>
  )
}

export default FrameSelector
